import { useTranslation } from "react-i18next";
import { VOUCHER_CUSTOMER_ASSOCIATED, VOUCHER_CUSTOMER_NOT_ASSOCIATED } from "../../../component/Constants";

export const useVoucherCustomerAssociated = () => {
  const { t } = useTranslation(["salesmarketing"],{keyPrefix:'voucher'});

  const customerAssociatedFilterValues = [
    {
      value: VOUCHER_CUSTOMER_ASSOCIATED,
      label: t("customerAssociated.yes"),
    },
    {
      value: VOUCHER_CUSTOMER_NOT_ASSOCIATED,
      label: t("customerAssociated.no"),
    },
  ];

  return {
    customerAssociatedFilterValues,
  };
};
